<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-card header-tag="header" header-bg-variant="dark">
            <template #header>
              <p class="mb-0" style="">
                <strong>Potongan Asuransi</strong>
              </p>
            </template>
            <b-row>
              <b-col cols="12" md="12" lg="12">
                <b-button variant="primary" v-b-modal.modal-input><CIcon name="cil-plus" /> {{ $store.state.table.tambahModal }}</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="12" lg="12">
                <hr />
              </b-col>
            </b-row>

            <b-alert dismissible fade :show="showing" :variant="variant">{{ msg }}</b-alert>

            <b-row>
              <b-col md="3">
                <b-form-group :label="$store.state.table.perHalaman" label-for="per-page-select" label-cols-md="6" label-align-md="left" label-size="md" style="background-color: ">
                  <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="md"></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="6" offset-md="3">
                <b-form-group :label="$store.state.table.cari" label-for="filter-input" label-cols-md="3" label-align-md="right" label-size="md">
                  <b-input-group size="md">
                    <b-form-input id="filter-input" v-model.lazy="filter" type="search" :placeholder="$store.state.table.cariHolder"></b-form-input>

                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''" variant="danger">{{ $store.state.table.hapusCari }}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="12" lg="12">
                <b-table
                  :items="items"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  stacked="md"
                  responsive
                  show-empty
                  small
                  @filtered="onFiltered"
                  bordered
                  striped
                  hover
                  :busy="tableBusy"
                >
                  <template #cell(actions)="item">
                    <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="'Edit Data'" v-b-modal.modal-edit @click="(data = item.item), (edit = !edit)"
                      ><CIcon name="cil-pencil" /> {{ item.actions }}</b-button
                    >

                    <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="'Hapus Data'" v-b-modal.modal-delete @click="data = item.item"
                      ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
                    >
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="5" offset-md="7">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm"></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <modal-input :asuransi="asuransi" :karyawan="karyawan" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :asuransi="asuransi" :karyawan="karyawan" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </div>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  name: "asuransi",
  data() {
    return {
      showing: false,
      variant: "success",
      msg: "",
      data: "",
      edit: false,
      asuransi: [],
      karyawan: [],
      items: [
        {
          no: "-",
          namaKaryawan: "-",
          asuransi: "-",
          potongan: "-",
          nomor: "-",
        },
      ],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sortable: true,
          class: "table-number text-center",
        },
        {
          key: "namaKaryawan",
          label: "Karyawan",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "namaAsuransi",
          label: "Asuransi",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "potonganAsuransi",
          label: "Potongan",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "nomorAsuransi",
          label: "Nomor",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-2 text-center",
        },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      tableBusy: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  mounted() {
    // Set the initial number of items
    this.getDatas();
    this.getKaryawan();
    this.getAsuransi();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getDatas() {
      let vm = this;
      this.tableBusy = true;
      let list = await vm.$axios.get("poolPotonganAsuransi/list");
      this.items = list.data.data;
      // FOREACH diganti FOR
      // this.items.forEach((element, index) => {
      //   let x = this.items[index];
      //   x.no = index + 1;
      // });
      for (let i = 0; i < this.items.length; i++) {
        let x = this.items[i];
        x.no = i + 1;
      }
      this.totalRows = this.items.length;
      this.tableBusy = false;
    },
    async getAsuransi() {
      let listAsuransi = await this.$axios.get("masterAsuransi/list");
      this.asuransi = listAsuransi.data.data;
    },
    async getKaryawan() {
      let listKaryawan = await this.$axios.get("dataKaryawan/listKaryawan");
      this.karyawan = listKaryawan.data.data;
    },
    triggerAlert(event) {
      let vm = this;
      vm.showing = event.showing;
      vm.variant = event.variant;
      vm.msg = event.msg;
      vm.getDatas();
      setTimeout(() => {
        vm.showing = false;
      }, 4000);
    },
  },
};
</script>
